/** @jsx jsx */
import { jsx } from "theme-ui"
import { articleStyles } from "@src/theme"

const MarkdownBody = ({ html, ...props }) => (
  <div
    dangerouslySetInnerHTML={{ __html: html }}
    sx={{ ...articleStyles }}
    {...props}
  />
)

export default MarkdownBody
